import { QueryHookOptions, useQuery } from "@apollo/client";

import { CurrentUserDocument, CurrentUserQuery } from "@hire/schema";
import { hireAppUser } from "@hire/util/user";

export function useCurrentUser(opts?: QueryHookOptions<CurrentUserQuery>) {
  const { data, loading, error } = useQuery(CurrentUserDocument, opts ?? {});
  return [hireAppUser(data?.me), { loading, error }] as const;
}
